module.exports = __webpack_public_path__ + "img/jiagou.2c7b6e31.png";